import { REVENUE } from '../../data/revenue';

export default function RevenueChart() {
  const W = 760;
  const H = 380;
  const padL = 56;
  const padR = 24;
  const padT = 24;
  const padB = 56;
  const iw = W - padL - padR;
  const ih = H - padT - padB;

  const yMax = 450;
  const data = REVENUE;
  const bw = iw / (data.length + 1.5);
  const barW = bw * 0.66;

  const xAt = (i: number) => padL + bw * (i + 0.8);
  const yAt = (v: number) => padT + ih - (v / yMax) * ih;

  const ticks = [0, 100, 200, 300, 400];

  return (
    <svg
      viewBox={`0 0 ${W} ${H}`}
      className="chart-svg"
      role="img"
      aria-label="Mystar Engineering Group revenue, FY2018–FY2025 (¥100M, stacked by segment)"
    >
      {/* gridlines */}
      {ticks.map((t, i) => (
        <g key={i}>
          <line
            x1={padL}
            x2={padL + iw}
            y1={yAt(t)}
            y2={yAt(t)}
            stroke={t === 0 ? '#0F0F0F' : '#E8E5DE'}
            strokeDasharray={t === 0 ? '0' : '2,3'}
          />
          <text
            x={padL - 10}
            y={yAt(t) + 4}
            textAnchor="end"
            fontFamily="JetBrains Mono, monospace"
            fontSize="10.5"
            fill="#5B5C57"
          >
            {t}
          </text>
        </g>
      ))}

      {/* bars */}
      {data.map((d, i) => {
        const x = xAt(i) - barW / 2;
        const yInfra = yAt(d.infra);
        const yMecha = yAt(d.infra + d.mecha);
        const yOther = yAt(d.infra + d.mecha + d.other);
        return (
          <g key={i}>
            <rect x={x} y={yOther} width={barW} height={yMecha - yOther} fill="#FAD8D8" />
            <rect x={x} y={yMecha} width={barW} height={yInfra - yMecha} fill="#F09595" />
            <rect x={x} y={yInfra} width={barW} height={padT + ih - yInfra} fill="#E61919" />

            <text
              x={x + barW / 2}
              y={yOther - 8}
              textAnchor="middle"
              fontFamily="Inter Tight, sans-serif"
              fontWeight="600"
              fontSize="13.5"
              fill="#0F0F0F"
            >
              {d.total}
            </text>

            <text
              x={x + barW / 2}
              y={padT + ih + 18}
              textAnchor="middle"
              fontFamily="JetBrains Mono, monospace"
              fontSize="11"
              fill="#5B5C57"
            >
              FY{String(d.y).padStart(2, '0')}
            </text>
          </g>
        );
      })}

      <text
        x={padL - 10}
        y={padT - 8}
        textAnchor="end"
        fontFamily="JetBrains Mono, monospace"
        fontSize="10"
        fill="#5B5C57"
      >
        ¥100M
      </text>
    </svg>
  );
}
